import { Box } from "@mui/material";
import React from "react";
import { NewsData } from "../../Objects/NewsDate";

export interface NewsImageProps {
    newsData: NewsData
}

const NewsImage: React.FC<NewsImageProps> = ({
    newsData
}) => {
    if (!newsData.newsimg_id) {
        return null
    }
    return (
        <Box
            component="img"
            sx={{
                display: "block",
                width: 700,
                maxHeight: 600,
                maxWidth: "100%",
                objectFit: "contain",
                mx: "auto",
            }}
            src={`${process.env.REACT_APP_NEWS_IMAGE_URL}${newsData.newsimg_id}`}
        />
    );
}

export default NewsImage